import { render, staticRenderFns } from "./OrderStatusPending.vue?vue&type=template&id=02c597bc&"
import script from "./OrderStatusPending.vue?vue&type=script&lang=js&"
export * from "./OrderStatusPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports